import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { doConfirmCorporateInformation } from '../actions/corporate-information';
import CorporateInformationSection from '../components/corporate/corporate-information';
export default connect(state => ({
  submitted: state.corporateInformation.confirmCorporateInformation.submitted,
  error: state.corporateInformation.confirmCorporateInformation.error
}), dispatch => bindActionCreators({
  doConfirmCorporateInformation
}, dispatch))(CorporateInformationSection);